import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Title from '../../commonComponents/Title';
import SubHeader from '../../commonComponents/pageLayout/SubHeader';
import translate from '../../commonComponents/translate';
import JourneyProp from '../journey/propTypes/journeyProp';
import GameTypeProp from '../challenges/propTypes/gameTypeProp';
import MarketOrderProp from '../shop/propTypes/orderProp';
import ContentContainer from '../../commonComponents/pageLayout/ContentContainer';
import NewsSection from './details/news/NewsSection';
import CoursesSection from './details/courses/CoursesSection';
import CourseProp from '../academy/propTypes/courseProp';
import ChallengeSection from './details/challenges/ChallengeSection';
import ServicesContext from '../../contextProviders/ServicesContext';
import JourneyPath from '../journey/overall/path/JourneyPath';
import TopicBanner from '../../commonComponents/pageLayout/header/TopicBanner';
import GameCategoriesProp from '../challenges/propTypes/gameCategoriesProp';
import PendingOrdersSection from './details/PendingOrdersSection';
import CurrencyProp from '../profile/propTypes/currencyProp';
import AccessSessionProp from '../../commonComponents/propTypes/accessSessionProp';
import UpcomingSessionsSection from './details/UpcomingSessionsSection';
import JourneyCarouselDashboard from '../academy/list/journeyBanner/JourneyCarouselDashboard';
import MetaContext from '../../contextProviders/MetaContext';
import DistributorBanner from '../../commonComponents/pageLayout/header/DistributorBanner';

/**
 * Dashboard main component, rendered from Router's path matching
 */
function Dashboard(props) {
  const {
    t,
    journeys,
    myCourses,
    // coursesWithCertificate,
    gameTypes,
    gameCategories,
    // hardSkills,
    pendingOrders,
    currencies,
    upcomingSessions,
    cookies,
  } = props;

  const { userPortalMenus } = useContext(MetaContext);
  const title =
    userPortalMenus.find(u => u.type === 'dashboard')?.name ||
    t('dashboard_title');
  const services = useContext(ServicesContext);
  const inboxDisabled =
    services && services.inbox && services.inbox.enabled === false;
  const performDisabled =
    services && services.perform && services.perform.enabled === false;

  const renderJourneyBanner = index => {
    const journey =
      index === 0 ? journeys[0] : journeys[index % journeys.length];
    if (!journey) {
      return null;
    }
    return index === 0 ? (
      <JourneyPath journey={journey} navigateOnClick />
    ) : (
      <JourneyCarouselDashboard t={t} />
    );
  };

  return (
    <Title title={title}>
      <ContentContainer>
        <SubHeader title={title} />
        <TopicBanner />
        <DistributorBanner cookies={cookies.cookies} />
        <div className="m-content">
          <div className="full-page-container-with-subheader">
            {!inboxDisabled && <NewsSection />}
            {!performDisabled && (
              <ChallengeSection
                gameTypes={gameTypes}
                gameCategories={gameCategories}
              />
            )}
            {!inboxDisabled && <>{renderJourneyBanner(0)}</>}
            {!performDisabled && (
              <>{renderJourneyBanner(inboxDisabled ? 1 : 2)}</>
            )}
            {myCourses.length > 0 && <CoursesSection myCourses={myCourses} />}
            {upcomingSessions.length > 0 && (
              <UpcomingSessionsSection
                t={t}
                upcomingSessions={upcomingSessions}
              />
            )}
            {pendingOrders.length > 0 && (
              <PendingOrdersSection
                t={t}
                pendingOrders={pendingOrders}
                currencies={currencies}
              />
            )}
            {/* TODO: Its not to implement now - Certify your Skills, Recommended Course by Skills */}
            {/* <CertificateSection */}
            {/*  coursesWithCertificate={coursesWithCertificate} */}
            {/*  hardSkills={hardSkills} */}
            {/* /> */}
          </div>
        </div>
      </ContentContainer>
    </Title>
  );
}

Dashboard.propTypes = {
  /** Translation function */
  t: PropTypes.func.isRequired,
  journeys: PropTypes.arrayOf(PropTypes.shape(JourneyProp.propType)).isRequired,
  myCourses: PropTypes.arrayOf(PropTypes.shape(CourseProp.propType)).isRequired,
  gameTypes: PropTypes.arrayOf(PropTypes.shape(GameTypeProp.propTypes))
    .isRequired,
  gameCategories: PropTypes.arrayOf(
    PropTypes.shape(GameCategoriesProp.propType),
  ).isRequired,
  pendingOrders: PropTypes.arrayOf(PropTypes.shape(MarketOrderProp.propTypes))
    .isRequired,
  currencies: PropTypes.arrayOf(PropTypes.shape(CurrencyProp.propType))
    .isRequired,
  upcomingSessions: PropTypes.arrayOf(
    PropTypes.shape(AccessSessionProp.propType),
  ).isRequired,
  cookies: PropTypes.shape({
    cookies: PropTypes.shape({
      isTestMode: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    }),
  }).isRequired,
};

export default translate(Dashboard);
